import { useContext, useState } from "react";
import { Form } from "react-bootstrap";
import Context from "../../Context";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";

const CardHisto3 = () => {
  const { histoClinica, showIcons } = useContext(Context);

  // TEXT AREA cirugias
  const localCirugias = JSON.parse(localStorage.getItem("localCirugias"));

  const [cirugias, setCirugias] = useState(localCirugias);

  const handleCirugias = (event) => {
    const inputCirugias = event.target.value;
    setCirugias(inputCirugias);
    /* histoClinica.cirugias = inputCirugias; */
    localStorage.setItem("localCirugias", JSON.stringify(inputCirugias));
  };

  // TEXT AREA partos
  const localPartos = JSON.parse(localStorage.getItem("localPartos"));

  const [partos, setPartos] = useState(localPartos);

  const handlePartos = (event) => {
    const inputPartos = event.target.value;
    setPartos(inputPartos);
    histoClinica.partos = inputPartos;

    localStorage.setItem("localPartos", JSON.stringify(inputPartos));
  };
  // TEXT AREA accidentes
  const localAccidentes = JSON.parse(localStorage.getItem("localAccidentes"));

  const [accidentes, setAccidentes] = useState(localAccidentes);

  const handleAccidentes = (event) => {
    const inputAccidentes = event.target.value;
    setAccidentes(inputAccidentes);
    histoClinica.Accidentes = inputAccidentes;

    localStorage.setItem("localAccidentes", JSON.stringify(inputAccidentes));
  };
  // TEXT AREA alimentacion
  const localAlimentacion = JSON.parse(
    localStorage.getItem("localAlimentacion")
  );

  const [alimentacion, setAlimentacion] = useState(localAlimentacion);

  const handleAlimentacion = (event) => {
    const inputAlimentacion = event.target.value;
    setAlimentacion(inputAlimentacion);
    histoClinica.alimentacion = inputAlimentacion;

    localStorage.setItem(
      "localAlimentacion",
      JSON.stringify(inputAlimentacion)
    );
  };

  const handleDeleteAll = () => {
    setCirugias("");
    setPartos("");
    setAccidentes("");
    setAlimentacion("");
    localStorage.removeItem(
      "localCirugias",
      "localPartos",
      "localAccidentes",
      "localAlimentacion"
    );
  };
  return (
    <>
      <div className="column">
        <div className="card-section">
          <div style={{ /*  width: 400, */ margin: 20 }}>
            <h4 className="text-center">Anamnesis 1.3</h4>
            <br />
            <h6>Cirugías</h6>
            <Form.Control
              as="textarea"
              placeholder="Escriba aquí..."
              value={cirugias}
              onChange={handleCirugias}
            />

            {/* <TextareaAutosize
              className="text-area-style"
              aria-label="empty textarea"
              placeholder="Escriba aquí..."
              value={ cirugias } 
              onChange={handleCirugias}
            /> */}

            <h6 className="mt-2">Partos</h6>
            <Form.Control
              as="textarea"
              placeholder="Escriba aquí..."
              value={partos}
              onChange={handlePartos}
            />

            <h6 className="mt-2">Accidentes / Traumatismos</h6>
            <Form.Control
              as="textarea"
              placeholder="Escriba aquí..."
              value={accidentes}
              onChange={handleAccidentes}
            />

            <h6 className="mt-2">Alimentación / Suplementación</h6>
            <Form.Control
              as="textarea"
              placeholder="Escriba aquí..."
              value={alimentacion}
              onChange={handleAlimentacion}
            />
          </div>
        </div>
        {showIcons && (
          <div className="icons-card-canvas mb-5">
            <img
              className="icon-trash-canvas"
              src="/assets/images/trash.png"
              alt="icon-image"
              onClick={handleDeleteAll}
            />
            {/* <img
            className="icon-trash-canvas"
            src="/assets/images/icon-download.png"
            alt="icon-image"
            onClick={() => alert("Imagen guardada")}
          /> */}
          </div>
        )}
      </div>
    </>
  );
};

export default CardHisto3;
